import { apiClient } from '@/services/ApiClient.js'

export default {
  getCampaigns() {
    return apiClient
      .get('tarfin-pro-campaigns')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getCampaign(id) {
    return apiClient
      .get('tarfin-pro-campaigns/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createCampaign(data) {
    return apiClient
      .post('tarfin-pro-campaigns', data)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateCampaign(id, data) {
    return apiClient
      .patch('tarfin-pro-campaigns/' + id, data)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
